import {
  RequiredFeatureCompanyLevelName,
  RequiredFeaturesCompanyLevel,
} from "@utils/feature-control/company/company-feature-control-types";

/**
 * Object that determines all different feature permission for users to get
 * access on the company level.
 */
export const requiredFeaturesCompanyLevel: RequiredFeaturesCompanyLevel<RequiredFeatureCompanyLevelName> =
  {
    /** Whether the user can see groups of the company. */
    [RequiredFeatureCompanyLevelName.canViewCompanyGroups]: {
      companySubscriptionRoles: ["dashboard-groups"],
    },

    /** Whether the user can see projects of the company related to the user. */
    [RequiredFeatureCompanyLevelName.canViewProjects]: {
      companySubscriptionRoles: ["dashboard-projects"],
    },

    /** Whether the user has permission to create new projects. */
    [RequiredFeatureCompanyLevelName.canCreateProjects]: {
      companySubscriptionRoles: ["project-create"],
    },

    /** Whether the user has permission to see the company members list. */
    [RequiredFeatureCompanyLevelName.canViewCompanyMembers]: {
      companySubscriptionRoles: ["dashboard-user-directory"],
    },

    /** Whether the user has permission to see the company analytics page. */
    [RequiredFeatureCompanyLevelName.canViewAnalytics]: {
      companySubscriptionRoles: ["dashboard-insights"],
    },

    /** Whether the user has permission to see the company premium analytics page. */
    [RequiredFeatureCompanyLevelName.canViewPremiumAnalytics]: {
      companySubscriptionRoles: ["company-insights"],
    },

    /** Whether the user has permission to see the company integrations page. */
    [RequiredFeatureCompanyLevelName.canViewIntegrations]: {
      companySubscriptionRoles: ["dashboard-integrations"],
    },

    /** Whether the user has permission to see the company settings page. */
    [RequiredFeatureCompanyLevelName.canViewWorkspaceSettings]: {
      companySubscriptionRoles: ["dashboard-settings"],
    },

    /** Whether the user has permission to export the workspace data */
    [RequiredFeatureCompanyLevelName.canExportWorkspace]: {
      companySubscriptionRoles: ["project-export"],
    },
  };
